import * as types from './types';

export const setKey = (key: string, val: any) => ({ type: types.SET_KEY, key, val });

export const deleteKey = (key: string) => ({ type: types.DELETE_KEY, key });
